



























import Vue from 'vue'
import { Component } from '@niknevis/vue-modules'
import QTable from 'quasar/src/components/table/QTable.js';
import { Prop, ProvideReactive } from 'vue-property-decorator'
import FilterRow from '@/modules/common/filter/components/shared/layout/FilterRow.vue'
import Heading from '@/modules/common/layout/components/shared/Heading.vue'
import TesTable from '@/modules/common/tes-table/components/shared/TesTable.vue'

@Component({
  components: {
    Heading,
    FilterRow,
    TesTable
  }
})
export default class WriterDepositsPage extends Vue {

  @ProvideReactive()
  @Prop() deposits

  search = null
  filters = null

  private rowComponent = null

  private columns: QTable['columns'] = [
    {
      name: 'id',
      field: 'id',
      label: 'شناسه',
      align: 'left'
    },
    {
      name: 'amount',
      field: 'amount',
      label: 'مبلغ (مبلغ)',
      align: 'left'
    },
    {
      name: 'payable_type',
      field: 'payable_type',
      label: 'نوع پرداخت',
      align: 'left'
    },
    {
      name: 'created_at',
      field: 'created_at',
      label: 'زمان',
      align: 'left'
    },
    {
      name: 'operation',
      label: '',
      field: 'operation',
      align: 'left'
    }
  ]

}
